module.exports = __webpack_public_path__ + "static/media/20260331_video_search.c92c3378.png";